import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { BUTTON_TYPES } from '@edassist-ui/button';
import { MODAL_SIZES } from '@edassist-ui/modal';
import { ActiveProductService, AuthenticationService, Product, User } from '@edassist/api';
import {
	AppConfigService,
	constants,
	HybridAppService,
	ParticipantUtilityService,
	PRODUCT_TYPES
} from '@edassist/common';
import { DropdownNavItemComponent } from '@edassist-ui/dropdown-nav-item';
import { Subscription } from 'rxjs';
import { Router } from '@angular/router';
import { DropdownService } from '@edassist-ui/dropdown';

@Component({
	selector: 'tu-profile-actions',
	templateUrl: './profile-actions.component.html',
	styleUrls: ['./profile-actions.component.scss']
})
export class ProfileActionsComponent implements OnInit, OnDestroy {
	constants = constants;
	BUTTON_TYPES = BUTTON_TYPES;
	MODAL_SIZES = MODAL_SIZES;
	isAdmin: boolean;
	participantId: number;
	activeProduct: number;
	showProfile = true;
	@ViewChild('dropdownContentNav')
	dropdownContentNav?: DropdownNavItemComponent;
	private readonly subscriptions = new Subscription();
	constructor(
		private readonly authService: AuthenticationService,
		readonly hybridAppService: HybridAppService,
		private readonly activeProductService: ActiveProductService,
		private readonly dropdownService: DropdownService,
		readonly router: Router
	) {}
	ngOnInit(): void {
		this.authService.currentUser
			.subscribe((user: User) => {
				this.isAdmin = user.userTypeId === this.constants.userType.clientAdmin;
				this.participantId = user.participantId;
			})
			.unsubscribe();

		this.subscriptions.add(
			this.activeProductService.activeProduct.subscribe((product: Product) => {
				this.activeProduct = product?.id;
				if (this.activeProduct === constants.PRODUCTS.CLIENT_CUSTOM_PATHWAY.ID) {
					this.showProfile = false;
				} else {
					this.showProfile = true;
				}
			})
		);
	}

	navigateToProfile(): void {
		const clientId = ParticipantUtilityService.getClientLoginDetails()?.clientId;
		if (AppConfigService.isNewProfilePageEnabled(clientId) && this.activeProduct !== PRODUCT_TYPES.loan) {
			this.dropdownService.close(constants.dropdownIds.profileActions);
			this.router.navigate([`/profile/${this.participantId}`]);
		} else {
			this.hybridAppService.navigateToUrl(`${this.constants.BASE_APP_ROUTES.profile}/${this.participantId}`);
		}
	}

	navigateToChangePassword(): void {
		this.hybridAppService.navigateToUrl(`${this.constants.BASE_APP_ROUTES.changePassword}/${this.participantId}`);
	}

	handleDropdownOnKeydown(): void {
		this.dropdownContentNav.toggleDropDown();
	}

	ngOnDestroy(): void {
		this.subscriptions.unsubscribe();
	}
}
